module.exports = __webpack_public_path__ + "img/aeroland-tab-content-image-02.649de21a.jpg";